import { ArrowLeft } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { env } from 'src/env';

export const GoBackButton = () => {
  const handleBackButtonClick = () => {
    window.location.href = env.REACT_APP_SUPER_NINJA_URL;
  };

  return (
    <Button color="transparent" shape="round" onClick={handleBackButtonClick}>
      <ArrowLeft size={SVG_SIZE_M} />
    </Button>
  );
};
